// extracted by mini-css-extract-plugin
module.exports = {"cashType":"CheckoutCashTypesCard_cashType__3ufaJ","active":"CheckoutCashTypesCard_active__35LiN","disabled":"CheckoutCashTypesCard_disabled__2g9wv"};